import {
  fetchGraphQL,
  fetchGeneral
} from '../Connections';

import {
  getFieldListString
} from './util';

export function queryGetInvoice(variables, fields) {
  const query = `query getInvoice($invoice_id: String) {
    getInvoice(invoice_id: $invoice_id) {
      ${getFieldListString(fields)}
    }
  }`;

  return fetchGraphQL({ query, variables });
}


export function queryListInvoices(variables, fields) {
  const query = `
    query listInvoices(
      $limit: Int,
      $offset: Int,
      $filters: [Filter],
      $filter_expressions: [FilterExpression],
      $order: Order,
      $orders: [Order]
    ) {
      listInvoices(
        limit: $limit,
        offset: $offset,
        filters: $filters,
        filter_expressions: $filter_expressions,
        order: $order,
        orders: $orders
      ) {
        ${getFieldListString(fields)}
      }
    }
  `;

  return fetchGraphQL({ query, variables });
}


export function queryCreateInvoice(variables, fields) {
  const query = `mutation createInvoice(
    $subscription_id: String!,
    $type: InvoiceTypeEnum,
    $invoice_due_date: String!,
    $notes: String,
    $detail_notes: String,
    $line_items: [LineItemInput]!,
    $parking_period_month: String!,
    $parking_period_year: Int!,
    $selectedFeeHistoryIds: [Int],
  ) {
    createInvoice(
      subscription_id: $subscription_id,
      type: $type,
      invoice_due_date: $invoice_due_date,
      notes: $notes,
      detail_notes: $detail_notes,
      line_items: $line_items,
      parking_period_month: $parking_period_month,
      parking_period_year: $parking_period_year,
      selectedFeeHistoryIds: $selectedFeeHistoryIds,
    ) {
      ${getFieldListString(fields)}
    }
  }`;

  return fetchGraphQL({ query, variables });
}


export function queryUpdateInvoice(variables, fields) {
  const query = `mutation updateInvoice(
    $invoice_id: String!,
    $invoice_type: InvoiceTypeEnum!,
    $invoice_due_date: String,
    $notes: String,
    $detail_notes: String,
    $line_items: [LineItemInput],
    $transactions: [TransactionInput]
  ) {
    updateInvoice(
      invoice_id: $invoice_id,
      invoice_type: $invoice_type,
      invoice_due_date: $invoice_due_date,
      notes: $notes,
      detail_notes: $detail_notes,
      line_items: $line_items,
      transactions: $transactions
    ) {
      ${getFieldListString(fields)}
    }
  }`;

  return fetchGraphQL({ query, variables });
}


export function queryGetInvoiceReport(options) {
  return fetchGeneral('/invoice_report', {
    method: 'POST',
    body: JSON.stringify(options)
  });
}


export function queryGetInvoicePDF(options) {
  return fetchGeneral('/invoice_pdf', {
    method: 'POST',
    body: JSON.stringify(options)
  });
}

export function queryResendInvoiceEmail(options) {
  return fetchGeneral('/invoice_email', {
    method: 'POST',
    body: JSON.stringify(options)
  });
}
